import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Env } from '../env';
import { RoleDto } from '../dto/role.dto';
import { Observable } from 'rxjs/Observable';
import { Role } from '../models/role';

@Injectable()
export class RoleService {

  constructor(private http: HttpClient, private global: Env) { }

  getAll(): Observable<Role[]> {
    const url = this.global.roles;
    return this.http.get(url).map((res: Role[]) => {
      return res;
    });
  }

  getInfoDetail(id: number): Observable<Role> {
    const url = this.global.roles + '/' + id;
    return this.http.get(url).map((res: Role) => {
      return res;
    });
  }

  createRole(dto: RoleDto): Observable<Role> {
    const url = this.global.roles;
    return this.http.post(url, JSON.stringify(dto)).map((res: Role) => {
      return res;
    });
  }

  updateRole(id: number, dto: RoleDto): Observable<Role> {
    const url = this.global.roles + '/' + id;
    return this.http.post(url, JSON.stringify(dto)).map((res: Role) => {
      return res;
    });
  }

  create(data: object): any{
    let token = localStorage.getItem('token');
    let url = this.global.roles;

    const body = {
      'name': data['name'],
      'description': data['description']
    };

    this.http.post(url, body).subscribe(
      data => {
	      return data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
        console.log('An error occurred:', err.error.message);
        } else {
        console.log('Backend returned status code: ', err.status);
        console.log('Response body:', err.error);
        }
      }
   );

  }

  update(data: object): any{

    const url = this.global.roles + '/' + data['id'];

    const body = {
      'name': data['name'],
      'description': data['description']
    };

    this.http.post(url, body).subscribe(
      data => {
	      return data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
        console.log('An error occurred:', err.error.message);
        } else {
        console.log('Backend returned status code: ', err.status);
        console.log('Response body:', err.error);
        }
      }
   );

  }

  deleteRole(id: number): any{

    const url = this.global.roles + '/delete/' + id;

    this.http.post(url, null).subscribe(
      data => {
        return data;
        },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log('Ocurrió un error:', err.error.message);
        } else {
          console.log('Backend devuelto código de estado: ', err.status);
          console.log('Response body:', err.error);
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/services/role.service.ts